import React from 'react'
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom'
import { withRouter } from 'react-router'
import ReactGA from 'react-ga'
import envFromHostname from '@toasttab/env-from-hostname'

import { OOGlobalsConsumer } from '../OOGlobalsProvider/OOGlobalsProvider'
import { OutpostProvider } from '../OutpostProvider/OutpostProvider'
import RestaurantPage from '../RestaurantPage/RestaurantPage'
import { RestaurantProvider } from '../RestaurantProvider/RestaurantProvider'
import { ReactRouterHistoryTracker } from '../ReactGAUtils/ReactGAUtils'
import { TriggerRoutechange } from '../TriggerRoutechange/TriggerRoutechange'
import { ServiceAvailabilityProvider } from '../ServiceAvailabilityProvider/ServiceAvaialbilityProvider'

import { AnalyticsProvider } from '../AnalyticsProvider/AnalyticsProvider'
import * as heapAnalytics from '../../third-party/HeapAnalytics'

const env = envFromHostname(window.location.hostname)
const testMode = env === 'dev'
ReactGA.initialize('UA-31548241-5', {
  testMode,
  debug: false,
  gaOptions: {
    sampleRate: 20
  }
})
ReactGA.set({
  appName: process.env.PKG_NAME,
  appVersion: process.env.PKG_VERSION
})
ReactGA.plugin.require('ec')
const EventTracker = withRouter(ReactRouterHistoryTracker)

export const OnlineOrderingApp = () => (
  <OOGlobalsConsumer>
    {({restaurantGuid, managementGroupGuid, routerBasename, shortUrl, outpostIdentifier}) => (
      <ServiceAvailabilityProvider>
        <AnalyticsProvider analyticsProxy={heapAnalytics}>
          <RestaurantProvider restaurantGuid={restaurantGuid} shortUrl={shortUrl}>
            <React.Fragment>
              <OutpostProvider diningOptionGuid={outpostIdentifier}>
                <BrowserRouter basename={routerBasename}>
                  <Route component={TriggerRoutechange} />
                  <EventTracker>
                    <Switch>
                      <Route component={RestaurantPage} path='/' />
                      <Redirect to='/' />
                    </Switch>
                  </EventTracker>
                </BrowserRouter>
              </OutpostProvider>
            </React.Fragment>
          </RestaurantProvider>
        </AnalyticsProvider>
      </ServiceAvailabilityProvider>
    )}
  </OOGlobalsConsumer>
)

export default OnlineOrderingApp
